import React from 'react';

import Laser from '../Laser';
import styles from './TaskResponseImageTranscription.module.css';

import MenuTranscibedSection from './MenuTranscibedSection';

const TaskResponseImageTranscription = ({ animate }) => (
  <div className="relative">
    <div className="relative overflow-hidden">
      <Laser animate={animate} />
      <img src="/static/img/examples/image-transcription.jpg" alt="menu on a chalkboard" />
    </div>
    <div
      className={`${styles.transcriptionWrapper} bg-white bg-opacity-80 p-2 flex flex-col absolute top-0 right-0 bottom-0`}
    >
      <p className="text-base text-black">Transcribe this menu</p>
      <div className="overflow-auto h-full relative">
        <ul className="absolute inset-0">
          <MenuTranscibedSection
            name="Coffees(6)"
            items={[
              {
                name: 'Espresso',
                prices: ['1.50', '2']
              },
              {
                name: 'Espresso freddo',
                prices: ['2']
              },
              {
                name: 'Cappucccino',
                prices: ['2']
              },
              {
                name: 'Cappucccino freddo',
                prices: ['2']
              },
              {
                name: 'Filter Coffee',
                prices: ['2']
              },
              {
                name: 'Greek Coffee',
                prices: ['1.50', '2']
              }
            ]}
            margin
            animate={animate}
            delay={1500}
          />
          <MenuTranscibedSection
            name="Shakes & Drinks(6)"
            items={[
              {
                name: 'Milk Shakes',
                prices: ['3.50']
              },
              {
                name: 'Fresh Juice',
                prices: ['2.50']
              },
              {
                name: 'Hot Milk',
                prices: ['1.50']
              },
              {
                name: 'Tea',
                prices: ['1']
              },
              {
                name: 'Hot Chocolate',
                prices: ['2']
              },
              {
                name: 'Cold chocolate',
                prices: ['2']
              }
            ]}
            animate={animate}
            delay={1500}
          />
        </ul>
      </div>
    </div>
  </div>
);

export default TaskResponseImageTranscription;
